<template>

  <div class="bg-background min-h-screen">

    <!-- Toast Notification -->

    <Toast

      :show="showToast"

      :type="toastType"

      :title="toastTitle"

      :message="toastMessage"

      :action-label="toastActionLabel"

      @close="showToast = false"

      @action="handleToastAction"

    />



    <!-- Login Register Prompt -->

    <LoginRegisterPrompt

      :show="showLoginPrompt"

      @login="handleLogin"

      @register="handleRegister"

      @cancel="handleCancel"

    />






    <!-- Page Header -->

    <section class="bg-card border-b border-border">

      <div class="container mx-auto px-4 sm:px-6 py-4">

        <div class="flex items-start gap-3">

          <div

            class="w-10 h-10 rounded-lg bg-blue-500/15 flex items-center justify-center flex-shrink-0"

          >

            <i class="fas fa-briefcase text-blue-600 dark:text-blue-400 text-lg"></i>

          </div>

          <div class="min-w-0">

            <h1 class="text-xl font-bold text-foreground leading-tight">
              Discover Better Jobs in Seconds
            </h1>

            <p

              v-if="!isViewingSimilarJobs"

              class="text-sm text-muted-foreground leading-snug"

            >

            Instantly filter and find high-quality jobs without wasting hours scrolling

            </p>

          </div>

        </div>

      </div>

    </section>



    <!-- Search and Filters -->

    <section class="bg-card border-b border-border">

      <div class="container mx-auto px-4 sm:px-6 py-4">

        <!-- Hide search when viewing similar jobs -->

        <div

          v-if="!isViewingSimilarJobs"

          class="flex flex-col md:flex-row gap-3 mb-4"

        >

          <!-- Main Search Input -->

          <div class="flex-1 relative">

            <span class="absolute inset-y-0 left-0 flex items-center pl-4">

              <i class="fas fa-search text-muted-foreground"></i>

            </span>

            <div class="relative">

              <input

                v-model="searchQuery"

                type="text"

                class="w-full pl-11 pr-11 py-2.5 rounded-xl border border-input bg-background text-foreground focus:ring-2 focus:ring-primary/20 focus:border-primary text-base shadow-sm transition-all"

                placeholder="Job title, keywords, or company name"

                @focus="onSearchFocus"

                @blur="onSearchBlur"

                @input="onSearchInput"

                @keyup.enter="searchJobs"

              />



              <!-- Clear button (X) -->

              <button

                v-if="searchQuery.trim()"

                @click="clearSearch"

                class="absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-6 flex items-center justify-center rounded-full bg-muted hover:bg-accent text-muted-foreground hover:text-foreground transition-all"

                type="button"

              >

                <i class="fas fa-times text-xs"></i>

              </button>

            </div>



            <!-- Search history dropdown (logged-in users) -->

            <div

              v-if="showSearchHistoryDropdown && currentSearchHistory.length"

              class="absolute left-0 right-0 mt-1 z-50 bg-card border border-border rounded-lg shadow-lg overflow-hidden"

            >

              <div class="px-4 py-2 text-xs text-muted-foreground bg-muted">

                <span>{{

                  showFullHistory ? "All searches" : "Recent searches"

                }}</span>

              </div>



              <!-- Search history items -->

              <div class="max-h-64 overflow-y-auto">

                <button

                  v-for="item in currentSearchHistory"

                  :key="item.query"

                  type="button"

                  class="w-full text-left px-4 py-2 hover:bg-accent flex items-center justify-between gap-2 group"

                  @mousedown.prevent="selectSearchHistory(item.query)"

                >

                  <div class="flex items-center gap-2 flex-1 min-w-0">

                    <i class="fas fa-history text-muted-foreground"></i>

                    <span class="truncate">{{ item.query }}</span>

                  </div>

                  <div class="flex items-center gap-2">

                    <div

                      v-if="item.new_jobs_count > 0"

                      class="bg-green-500/15 text-green-700 dark:text-green-300 px-2 py-1 rounded-full text-xs font-medium"

                    >

                      {{ item.new_jobs_count }} new

                    </div>

                    <button

                      type="button"

                      class="p-1 text-muted-foreground hover:text-red-500 opacity-100 sm:opacity-0 sm:group-hover:opacity-100 transition-all duration-200"

                      @mousedown.prevent.stop="

                        deleteSearchHistoryItem(item.query)

                      "

                      title="Delete search history"

                    >

                      <i class="fas fa-times text-sm"></i>

                    </button>

                  </div>

                </button>

              </div>



              <!-- Footer with See More/Clear All buttons -->

              <div

                class="border-t border-border px-2 py-2 bg-muted flex justify-between items-center"

              >

                <div class="flex-1"></div>

                <button

                  v-if="!showFullHistory && searchHistory.length >= 3"

                  @click="handleSeeMore"

                  class="text-sm text-primary hover:underline px-2 py-1"

                >

                  See more

                </button>

                <div

                  v-if="showFullHistory"

                  class="flex justify-between items-center w-full"

                >

                  <button

                    @click="handleClearAll"

                    class="text-sm text-red-600 hover:text-red-700 px-2 py-1"

                  >

                    Clear history

                  </button>

                  <button

                    @click="handleHide"

                    class="text-sm text-muted-foreground hover:text-foreground px-2 py-1"

                  >

                    Hide

                  </button>

                </div>

              </div>

            </div>

          </div>



          <!-- Search Button -->

          <button

            @click="searchJobs"

            class="inline-flex items-center justify-center bg-primary hover:bg-primary/90 text-primary-foreground px-5 py-2.5 rounded-xl font-medium transition-colors w-full md:w-auto text-sm"

          >

            <i class="fas fa-search mr-2"></i>Search

          </button>

        </div>



        <!-- Back to all jobs button when viewing similar jobs -->

        <div v-else class="mb-4">

          <button

            @click="goBackToAllJobs"

            class="inline-flex items-center px-4 py-2 bg-muted hover:bg-accent text-foreground rounded transition"

          >

            <i class="fas fa-arrow-left mr-2"></i> Back to All Jobs

          </button>

        </div>



        <div v-if="false && showFilters" class="bg-card rounded-lg shadow-lg mt-6">

          <div class="p-6 space-y-6">

            <!-- Header with working close button -->

            <div class="flex justify-between items-center">

              <h3 class="text-xl font-bold text-foreground">Smart Filters</h3>

              <button

                @click="toggleFilters"

                class="text-muted-foreground hover:text-red-600"

                aria-label="Close filters"

              >

                <i class="fas fa-times"></i>

              </button>

            </div>



            <!-- Filters grid -->

            <div

              class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6"

            >

              <!-- Job Type -->

              <div class="flex flex-col">

                <label class="text-sm font-medium text-muted-foreground mb-1"

                  >Job Type</label

                >

                <select

                  v-model="filters.jobType"

                  class="rounded-lg border-border focus:ring-primary focus:border-primary"

                >

                  <option value="">Any Type</option>

                  <option>Full-time</option>

                  <option>Part-time</option>

                  <option>Contract</option>

                  <option>Gig</option>

                  <option>Remote</option>

                  <option>Hybrid</option>

                  <option>On-site</option>

                </select>

              </div>



              <!-- Source -->

              <div class="flex flex-col">

                <label class="text-sm font-medium text-muted-foreground mb-1"

                  >Source</label

                >

                <select

                  v-model="filters.source"

                  class="rounded-lg border-border focus:ring-primary focus:border-primary"

                >

                  <option value="">All Sources</option>

                  <option v-if="oljUnlocked" value="olj">OnlineJobs.ph</option>

                  <option value="kalibrr">Kalibrr</option>

                  <!-- HIDDEN: LinkedIn -->
                  <!-- <option value="linkedin">LinkedIn</option> -->
                  <!-- /HIDDEN: LinkedIn -->

                  <option value="cloudstaff">Cloudstaff</option>

                  <option value="jobstreet">JobStreet</option>

                </select>

              </div>



              <!-- Date Posted -->

              <div class="flex flex-col">

                <label class="text-sm font-medium text-muted-foreground mb-1"

                  >Date Posted</label

                >

                <select

                  v-model="filters.datePosted"

                  class="rounded-lg border-border focus:ring-primary focus:border-primary"

                >

                  <option value="">Recent default (~30 days, fast)</option>

                  <option value="all">All time (full archive, slower)</option>

                  <option value="today">Today</option>

                  <option value="3days">Last 3 days</option>

                  <option value="week">Last week</option>

                  <option value="month">Last month</option>

                </select>

              </div>



              <!-- Skills & Tags (spans two columns on md+) -->

              <div class="md:col-span-2 flex flex-col">

                <label class="text-sm font-medium text-muted-foreground mb-1"

                  >Skills & Tags</label

                >

                <div class="flex flex-wrap gap-2 mt-2">

                  <div

                    v-for="tag in popularTags"

                    :key="tag.id"

                    @click="toggleTag(tag)"

                    :class="[

                      'px-3 py-1 rounded-full text-sm cursor-pointer transition-colors',

                      selectedTags.includes(tag.id)

                        ? 'bg-primary text-primary-foreground'

                        : 'bg-muted text-foreground hover:bg-muted',

                    ]"

                  >

                    {{ tag.name }}

                  </div>

                </div>

                <div class="relative mt-3">

                  <input

                    v-model="tagInput"

                    @keyup.enter="addCustomTag"

                    type="text"

                    class="w-full px-3 py-2 rounded-lg border border-border focus:outline-none focus:ring-primary focus:border-primary"

                    placeholder="Add custom tag…"

                  />

                  <button

                    @click="addCustomTag"

                    class="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-primary"

                  >

                    <i class="fas fa-plus text-xs"></i>

                  </button>

                </div>

              </div>

            </div>



            <!-- Action buttons -->

            <div class="flex justify-end space-x-3 mt-6">

              <button

                @click="resetFilters"

                class="px-4 py-2 bg-muted text-muted-foreground rounded hover:bg-accent"

              >

                Reset

              </button>

              <button

                @click="applyFilters"

                class="px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary-dark"

              >

                Apply

              </button>

            </div>

          </div>

        </div>

      </div>

    </section>



    <section class="container mx-auto py-6 sm:py-10 px-4 sm:px-6">

      <div

        :class="

          !isViewingSimilarJobs

            ? 'lg:grid lg:grid-cols-[280px_minmax(0,1fr)] lg:gap-8'

            : ''

        "

      >

        <div
          v-if="!isViewingSimilarJobs"
          class="mb-4 lg:hidden"
        >
          <button
            type="button"
            @click="toggleFilters"
            class="w-full inline-flex items-center justify-between gap-3 rounded-xl border border-border bg-card px-4 py-3 text-sm font-semibold text-foreground shadow-sm transition-colors hover:bg-accent"
            :aria-expanded="showFilters ? 'true' : 'false'"
            aria-controls="job-listing-smart-filters"
            :aria-label="showFilters ? 'Hide smart filters' : 'Show smart filters'"
          >
            <span class="inline-flex items-center gap-2 min-w-0">
              <i class="fas fa-filter text-primary"></i>
              <span>{{ showFilters ? "Hide Smart Filters" : "Show Smart Filters" }}</span>
            </span>
            <i
              :class="[
                'fas text-xs text-muted-foreground transition-transform flex-shrink-0',
                showFilters ? 'fa-chevron-up' : 'fa-chevron-down',
              ]"
            ></i>
          </button>
        </div>

        <aside

          v-if="!isViewingSimilarJobs"

          id="job-listing-smart-filters"

          :class="[
            'mb-6 lg:mb-0',
            showFilters ? 'block' : 'hidden lg:block',
          ]"

        >

          <div class="bg-card border border-border rounded-xl shadow-sm p-5">

            <div class="flex items-center justify-between gap-3 mb-5">

              <div>

                <h3 class="text-lg font-semibold text-foreground">Smart Filters</h3>

                <p class="text-sm text-muted-foreground">Keep filters visible while browsing jobs.</p>

              </div>

              <button
                type="button"
                @click="toggleFilters"
                class="h-10 w-10 flex items-center justify-center bg-muted border border-border hover:bg-accent text-muted-foreground rounded-xl transition-all lg:hidden"
                aria-label="Hide smart filters"
              >
                <i class="fas fa-times"></i>
              </button>

              <span class="relative group/reset">
                <button

                  type="button"

                  @click="resetFilters"

                  class="h-10 w-10 flex items-center justify-center bg-muted border border-border hover:bg-accent text-muted-foreground rounded-xl transition-all"

                >

                  <i class="fas fa-rotate-left"></i>

                </button>
                <span class="pointer-events-none absolute bottom-full right-0 mb-2 whitespace-nowrap rounded-lg bg-gray-900 text-white text-xs font-medium px-2.5 py-1.5 opacity-0 group-hover/reset:opacity-100 transition-opacity z-50 shadow-lg">
                  Reset filters
                  <span class="absolute top-full right-3 border-4 border-transparent border-t-gray-900"></span>
                </span>
              </span>

            </div>

            <div class="space-y-4">

              <div class="flex flex-col bg-card border border-border rounded-xl p-3">

                <label class="text-sm font-medium text-muted-foreground mb-1.5">Source</label>

                <div class="relative">
                  <select
                    v-model="filters.source"
                    @change="applyFilters"
                    class="w-full h-11 px-3 pr-10 rounded-xl border border-border bg-muted/80 appearance-none text-sm font-medium text-muted-foreground focus:ring-2 focus:ring-primary/20 focus:border-primary"
                  >
                    <option value="">All Sources</option>
                    <option v-if="oljUnlocked" value="olj">OnlineJobs.ph</option>
                    <option value="cloudstaff">Cloudstaff</option>
                    <option value="emapta">Emapta</option>
                    <option value="bossjob">BossJob.ph</option>
                    <option value="kalibrr">Kalibrr</option>
                    <option value="jobstreet">JobStreet</option>
                    <option value="VAWorkersPH">VAWorkers PH</option>
                    <option value="findtalent">FindTalent.ph</option>
                    <option value="hiretalent">HireTalent.ph</option>
                    <option value="ofmjobs">OFM Jobs</option>
                    <option value="upwork">Upwork</option>
                  </select>
                  <i class="fas fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none"></i>
                </div>

              </div>

              <div class="flex flex-col bg-card border border-border rounded-xl p-3">

                <label class="text-sm font-medium text-muted-foreground mb-1.5">Sort By</label>

                <div class="relative">
                  <select
                    v-model="sortBy"
                    @change="applyFilters"
                    class="w-full h-11 px-3 pr-10 rounded-xl border border-border bg-muted/80 appearance-none text-sm font-medium text-muted-foreground focus:ring-2 focus:ring-primary/20 focus:border-primary"
                  >
                    <option value="recommended">Recommended</option>
                    <option value="date_desc">Newest First</option>
                    <option value="date_asc">Oldest First</option>
                  </select>
                  <i class="fas fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none"></i>
                </div>

              </div>

              <div class="flex flex-col bg-card border border-border rounded-xl p-3">

                <label class="text-sm font-medium text-muted-foreground mb-1.5">Job Type</label>

                <div class="relative">
                  <select
                    v-model="filters.jobType"
                    @change="applyFilters"
                    class="w-full h-11 px-3 pr-10 rounded-xl border border-border bg-muted/80 appearance-none text-sm font-medium text-muted-foreground focus:ring-2 focus:ring-primary/20 focus:border-primary"
                  >
                    <option value="">Any Type</option>
                    <option>Full-time</option>
                    <option>Part-time</option>
                    <option>Contract</option>
                    <option>Gig</option>
                    <option>Remote</option>
                    <option>Hybrid</option>
                    <option>On-site</option>
                  </select>
                  <i class="fas fa-chevron-down absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground pointer-events-none"></i>
                </div>

              </div>

              <div class="bg-card border border-border rounded-xl p-3">

                <label class="text-sm font-medium text-muted-foreground mb-2 block">Skills & Tags</label>

                <div class="max-h-52 overflow-y-auto pr-1 flex flex-wrap gap-2 content-start">

                  <div

                    v-for="tag in popularTags"

                    :key="tag.id"

                    @click="toggleTag(tag)"

                    :class="[

                      'px-3 py-1 rounded-full text-sm cursor-pointer transition-colors border',

                      selectedTags.includes(tag.id)

                        ? 'bg-primary text-primary-foreground border-primary'

                        : 'bg-muted text-muted-foreground border-border hover:bg-muted',

                    ]"

                  >

                    {{ tag.name }}

                  </div>

                </div>

                <div class="relative mt-3">

                  <input

                    v-model="tagInput"

                    @keyup.enter="addCustomTag"

                    type="text"

                    class="w-full px-3 py-2 rounded-xl border border-border bg-muted/80 focus:outline-none focus:ring-primary focus:border-primary"

                    placeholder="Add custom tag..."

                  />

                  <button

                    @click="addCustomTag"

                    class="absolute right-3 top-1/2 transform -translate-y-1/2 text-muted-foreground hover:text-primary"

                  >

                    <i class="fas fa-plus text-xs"></i>

                  </button>

                </div>

              </div>


            </div>

          </div>

        </aside>

        <div>




      <!-- Loading State -->

      <div v-if="loading" class="flex justify-center items-center py-12">

        <div

          class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"

        ></div>

      </div>



      <!-- Error State -->

      <div

        v-else-if="error"

        class="bg-red-500/10 border border-red-500/30 text-red-700 dark:text-red-300 px-4 py-3 rounded-lg mb-6"

      >

        <p>{{ error }}</p>

        <div class="mt-2 flex gap-2">

          <button

            @click="refreshJobsList"

            class="px-4 py-2 bg-red-500/15 hover:bg-red-500/25 text-red-700 dark:text-red-300 rounded-lg"

          >

            Try Again

          </button>

          <router-link

            v-if="isSearchLimitError"

            to="/subscription/plans"

            class="px-4 py-2 bg-primary hover:bg-primary-dark text-primary-foreground rounded-lg transition duration-200"

          >

            Upgrade Subscription

          </router-link>

        </div>

      </div>



      <!-- No Results -->

      <div

        v-else-if="hasInitialLoad && jobs.length === 0"

        class="bg-card rounded-xl border border-border shadow-sm p-8 text-center"

      >

        <img

          src="/images/no-results.svg"

          alt="No results"

          class="h-40 mx-auto mb-4"

        />

        <h3 class="text-xl font-semibold text-foreground mb-2">No jobs found</h3>

        <p class="text-muted-foreground mb-4">

          Try adjusting your search criteria or filters

        </p>

        <button

          @click="resetAll"

          class="px-6 py-2 bg-primary hover:bg-primary-dark text-primary-foreground rounded-lg transition duration-200"

        >

          Reset Search

        </button>

      </div>



      <!-- Results List with Search Count Status -->

      <template v-else>




<!-- Page indicator -->
<div v-if="jobs.length > 0 && totalPages > 1" class="text-xs text-muted-foreground text-right mb-2 pr-1">
  Page {{ currentPage }} of {{ totalPages }}
</div>


<!-- Job Results - Single Column Layout -->
<Transition name="jobs-page">
<div v-if="jobs.length > 0" :key="currentPage" class="max-w-6xl mx-auto space-y-4">
  <div
    v-for="job in displayedJobs"
    :key="job?.id"
    class="group bg-card rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-border hover:border-primary/30 overflow-hidden flex flex-col cursor-pointer"
    @click="handleJobCardClick(job)"
  >
    <!-- Card Header with Title + Employer + Actions -->
    <div class="p-6 pb-4">
      <div class="flex items-start justify-between gap-3">
        <div
          class="flex-1 min-w-0"
        >
          <div class="min-w-0">
            <h3 class="text-xl sm:text-2xl font-bold text-foreground leading-tight mb-2">
              <router-link :to="getJobDetailPath(job)" class="hover:text-primary transition" @click.stop>
                {{ job.title || "Untitled Position" }}
              </router-link>
            </h3>
            <p
              class="text-muted-foreground text-sm font-medium flex flex-wrap items-center gap-2"
            >
              <i class="fas fa-building text-muted-foreground text-xs"></i>
              <span class="break-words">
                {{
                  typeof job.employer === "string"
                    ? job.employer
                    : (job.employer && job.employer.name) || "Unknown Employer"
                }}
              </span>
              <span
                v-if="(job.employer && job.employer.total_posts > 0) || job.employer_total_posts > 0"
                class="text-muted-foreground text-xs font-medium"
              >({{ (job.employer && job.employer.total_posts) || job.employer_total_posts }} total job posts)</span>
            </p>
          </div>
        </div>

          <div class="flex items-center gap-2 self-start">
            <button
              type="button"
              @click.stop="shareJob(job)"
              class="p-2 rounded-full transition-all duration-200 flex-shrink-0 bg-muted text-muted-foreground hover:bg-blue-500/15 hover:text-blue-600 dark:hover:text-blue-400"
              title="Share this job"
            >
              <i class="fas fa-share-alt"></i>
            </button>

            <button
              type="button"
              @click.stop="toggleSaveJob(job)"
              class="p-2 rounded-full transition-all duration-200 flex-shrink-0"
              :class="
                isJobSaved(job.id)
                  ? 'bg-primary/10 text-primary hover:bg-accent hover:text-muted-foreground'
                  : 'bg-muted text-muted-foreground hover:bg-primary/10 hover:text-primary'
              "
              :title="
                isJobSaved(job.id)
                  ? 'Remove from saved jobs'
                  : 'Save this job'
              "
            >
              <i :class="isJobSaved(job.id) ? 'fas fa-bookmark' : 'far fa-bookmark'"></i>
            </button>

            <button
              type="button"
              @click.stop="hideJobAction(job)"
              class="p-2 rounded-full transition-all duration-200 flex-shrink-0 bg-muted text-muted-foreground hover:bg-red-500/15 hover:text-red-600 dark:hover:text-red-400"
              title="Hide this job"
            >
              <i class="fas fa-eye-slash"></i>
            </button>

            <span
              v-if="job.is_trending"
              class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-purple-500/15 text-purple-700 dark:text-purple-300 border border-purple-500/30"
            >
              Trending
            </span>
          </div>
        </div>
      </div>

    <div class="px-6 pb-2 flex-1 flex flex-col">
      <div class="flex flex-wrap gap-2 mb-4">
        <span
          v-if="job.source === 'olj'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: External"
        >
          <img
            src="/images/job-source-logos/olj-logo-blue.webp"
            alt="External source logo"
            class="h-4 w-auto object-contain"
          />
        </span>
        <!-- HIDDEN: LinkedIn -->
        <!-- <span
          v-else-if="job.source === 'linkedin'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold"
          style="
            color: #0a66c2;
            background: #e8f0fe;
            border: 1px solid #0a66c2;
          "
          title="Source: LinkedIn"
        >
          LinkedIn
        </span> -->
        <!-- /HIDDEN: LinkedIn -->
        <span
          v-else-if="job.source === 'jobstreet'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: JobStreet"
        >
          <img
            src="/images/job-source-logos/jobstreet-icon.png"
            alt="JobStreet"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-else-if="job.source === 'cloudstaff'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: Cloudstaff"
        >
          <img src="/images/job-source-logos/cloudstaff-logo.svg" alt="Cloudstaff" class="h-4 w-auto object-contain" />
        </span>
        <span
          v-else-if="job.source === 'emapta'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg border border-border"
          style="background-color:#00263F"
          title="Source: Emapta"
        >
          <img
            src="/images/job-source-logos/emapta-logo-full.svg"
            alt="Emapta"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-else-if="job.source === 'bossjob'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: BossJob.ph"
        >
          <img
            src="/images/job-source-logos/bossjob-logo.svg"
            alt="BossJob.ph"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-else-if="job.source === 'kalibrr'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: Kalibrr"
        >
          <img
            src="/images/job-source-logos/kalibrr-logo.png"
            alt="Kalibrr"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-else-if="job.source === 'VAWorkersPH'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: VAWorkers PH"
        >
          <img
            src="/images/job-source-logos/vaworkersph-logo.webp"
            alt="VAWorkers PH"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-else-if="job.source === 'findtalent'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: FindTalent.ph"
        >
          <img
            src="/images/job-source-logos/findtalent-icon.svg"
            alt="FindTalent.ph"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-else-if="job.source === 'hiretalent'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: HireTalent.ph"
        >
          <img
            src="/images/job-source-logos/hiretalent-logo.jpg"
            alt="HireTalent.ph"
            class="h-4 w-auto object-contain rounded"
          />
        </span>
        <span
          v-else-if="job.source === 'ofmjobs'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: OFM Jobs"
        >
          <img
            src="/images/job-source-logos/ofmjobs-icon.svg"
            alt="OFM Jobs"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-else-if="job.source === 'upwork'"
          class="inline-flex items-center px-2.5 py-1 rounded-lg bg-card border border-border"
          title="Source: Upwork"
        >
          <img
            src="/images/job-source-logos/upwork-icon.svg"
            alt="Upwork"
            class="h-4 w-auto object-contain"
          />
        </span>
        <span
          v-if="job.job_type"
          class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold bg-blue-500/15 text-blue-700 dark:text-blue-300 border border-blue-500/30"
        >
          <i class="fas fa-briefcase mr-1.5 text-blue-600 dark:text-blue-400"></i>
          {{ job.job_type }}
        </span>
        <span
          v-if="job.salary"
          class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold bg-green-500/15 text-green-700 dark:text-green-300 border border-green-500/30"
        >
          {{ job.salary }}
        </span>
        <span
          v-if="job.posted_at || job.date_posted"
          class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold bg-muted text-muted-foreground border border-border"
        >
          <i class="fas fa-clock mr-1.5 text-muted-foreground"></i>
          {{ formatPostedDateTime(job.posted_at || job.date_posted) }}
        </span>
      </div>



              <!-- Tags -->

              <div

                v-if="job.tags && job.tags.length > 0"

                class="flex flex-wrap gap-1.5 mb-4"

              >

                <span

                  v-for="tag in job.tags.slice(0, 3)"

                  :key="tag?.id || tag"

                  class="px-1 py-0.5 rounded-md text-xs bg-primary/10 text-primary font-medium"

                >

                  {{ tag?.name || "Unknown Tag" }}

                </span>

                <span

                  v-if="job.tags.length > 3"

                  class="px-2 py-0.5 rounded-md text-xs bg-muted text-muted-foreground"

                >

                  +{{ job.tags.length - 3 }}

                </span>

              </div>



              <!-- Match Score Badge -->
              <div v-if="false" class="mb-3">
                <span
                  :class="matchScoreBadgeClass(job.match_score)"
                  class="inline-flex items-center text-xs font-semibold px-2 py-0.5 rounded-full"
                >
                  <i class="fas fa-chart-bar mr-1"></i>
                  {{ job.match_score }}% match
                </span>
              </div>



              <!-- Similarity Indicator -->

              <div

                v-if="filters.similarToJobId && job.similarityScore"

                class="mb-3"

              >

                <div class="flex flex-wrap gap-2">

                  <span

                    class="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-medium"

                    :class="{

                      'bg-indigo-500/15 text-indigo-700 dark:text-indigo-300':

                        job.similarityLabel === 'Related',

                      'bg-blue-500/15 text-blue-700 dark:text-blue-300':

                        job.similarityLabel === 'Similar',

                      'bg-purple-500/15 text-purple-700 dark:text-purple-300':

                        job.similarityLabel === 'Very Similar',

                      'bg-green-500/15 text-green-700 dark:text-green-300':

                        job.similarityLabel === 'Highly Similar',

                      'bg-indigo-500/15 text-indigo-700 dark:text-indigo-300': !job.similarityLabel,

                    }"

                  >

                    <i class="fas fa-link mr-1.5"></i>

                    {{

                      job.similarityLabel ||

                      getSimilarityLabel(job.similarityScore)

                    }}

                  </span>

                </div>

              </div>



              <!-- Job Description Preview -->
              
              <div v-if="truncateDescription(job)" class="mb-4">
                <p class="text-muted-foreground text-sm leading-relaxed line-clamp-2 mb-4">
                  {{ truncateDescription(job) }}
                  
                </p>
                
                <!-- Show "Read more" indicator if description is long -->
                
                <p v-if="truncateDescription(job).length > 420" class="text-primary text-xs font-medium mt-2">
                  
                  <i class="fas fa-info-circle mr-1"></i>
                  
                  <a :href="getJobDetailPath(job)" class="text-primary hover:underline" @click.stop>
                    See full description
                  </a>
                  
                </p>
                
              </div>
              
              <!-- No Description Fallback -->
              
              <div v-else class="mb-4">
                
                <p class="text-muted-foreground text-sm italic">
                  
                  <i class="fas fa-file-alt mr-1"></i>
                  
                  No description available
                  
                </p>
                
              </div>

            </div>



            <!-- Card Footer with Actions -->

            <div class="p-5 pt-0 mt-auto">

              <!-- Status Badge (if not active) -->

              <div v-if="job.status && job.status !== 'active'" class="mb-3">

                <span

                  :class="getStatusBadgeClass(job.status)"

                  class="w-full px-3 py-2 rounded-lg text-sm font-medium inline-flex items-center justify-center"

                >

                  <i :class="getStatusIcon(job.status)" class="mr-2"></i>

                  {{ getStatusText(job.status) }}

                </span>

              </div>



              <!-- Action Buttons -->

              <div class="flex gap-2">

                <button

                  v-if="job.status && job.status !== 'active'"

                  :class="getStatusButtonClass(job.status)"

                  class="flex-1 px-4 py-2.5 rounded-lg cursor-not-allowed text-sm font-medium"

                  disabled

                >

                  <i :class="getStatusIcon(job.status)" class="mr-2"></i>

                  {{ getStatusText(job.status) }}

                </button>

      
              </div>

            </div>

          </div>

        </div>
</Transition>



        <!-- Pagination -->

        <div v-if="jobs.length > 0" class="mt-10 flex justify-center">

          <nav

            class="flex items-center gap-2 bg-card rounded-xl shadow-sm border border-border p-2"

          >

            <button

              @click="prevPage"

              :disabled="currentPage === 1"

              class="w-10 h-10 rounded-lg flex items-center justify-center transition-all text-sm font-medium"

              :class="[

                currentPage === 1

                  ? 'text-muted-foreground cursor-not-allowed'

                  : 'text-muted-foreground hover:bg-accent hover:text-foreground',

              ]"

            >

              <i class="fas fa-chevron-left"></i>

            </button>



            <button

              v-for="page in displayedPages"

              :key="page"

              @click="goToPage(page)"

              class="w-10 h-10 rounded-lg flex items-center justify-center transition-all text-sm font-medium"

              :class="[

                page === currentPage

                  ? 'bg-primary text-primary-foreground shadow-sm'

                  : 'text-muted-foreground hover:bg-accent hover:text-foreground',

              ]"

            >

              {{ page }}

            </button>



            <button

              @click="nextPage"

              :disabled="currentPage === totalPages"

              class="w-10 h-10 rounded-lg flex items-center justify-center transition-all text-sm font-medium"

              :class="[

                currentPage === totalPages

                  ? 'text-muted-foreground cursor-not-allowed'

                  : 'text-muted-foreground hover:bg-accent hover:text-foreground',

              ]"

            >

              <i class="fas fa-chevron-right"></i>

            </button>

          </nav>

        </div>

      </template>

        </div>

      </div>

    </section>

  </div>

</template>



<script>

import { ref, computed, onMounted, watch, onBeforeUnmount, nextTick } from "vue";

import { useRouter, useRoute } from "vue-router";

import apiClient from "@/services/api";

import { useStore } from "vuex";

import Toast from "@/components/Toast.vue";

import authStore from "@/store/auth"; // Import auth store

import LoginRegisterPrompt from "@/components/LoginRegisterPrompt.vue";

import { buildJobDetailsPath } from "@/utils/slug";

import { resolveEmployerLogoUrl } from "@/utils/imageUrl";



export default {

  name: "JobListing",

  components: {

    Toast,

    LoginRegisterPrompt,

  },

  setup() {

    const router = useRouter();

    const route = useRoute();

    const store = useStore();



    // Toast State

    const showToast = ref(false);

    const toastType = ref("success");

    const toastTitle = ref("");

    const toastMessage = ref("");

    const toastActionLabel = ref("");

    const toastActionCallback = ref(null);

    const handleToastAction = () => {

      if (typeof toastActionCallback.value === "function") {

        toastActionCallback.value();

      }

      showToast.value = false;

    };



    // Search state

    const searchQuery = ref("");

    const jobs = ref([]);

    const totalJobs = ref(0);

    const loading = ref(true); // Start with true to show loading initially

    const error = ref(null);

    const showFilters = ref(false);

    const isMounted = ref(true);

    const hasInitialLoad = ref(false); // Track if we've completed initial load



    // Search history state

    const searchHistory = ref([]);

    const allSearchHistory = ref([]);

    const showSearchHistoryDropdown = ref(false);

    const searchHistoryLoaded = ref(false);

    const showFullHistory = ref(false);

    const totalSearchHistoryCount = ref(0); // Track total count



    // LocalStorage for viewed queries

    const VIEWED_QUERIES_KEY = "applypa_viewed_search_queries";

    const viewedQueries = ref(new Set());



    // Load viewed queries from localStorage

    const loadViewedQueries = () => {

      try {

        const stored = localStorage.getItem(VIEWED_QUERIES_KEY);

        if (stored) {

          viewedQueries.value = new Set(JSON.parse(stored));

        }

      } catch (error) {

        console.error("Failed to load viewed queries:", error);

      }

    };



    // Save viewed queries to localStorage

    const saveViewedQueries = () => {

      try {

        localStorage.setItem(

          VIEWED_QUERIES_KEY,

          JSON.stringify(Array.from(viewedQueries.value)),

        );

      } catch (error) {

        console.error("Failed to save viewed queries:", error);

      }

    };



    let hideSearchHistoryTimer = null;



    const currentSearchHistory = computed(() => {

      const history = showFullHistory.value

        ? allSearchHistory.value

        : searchHistory.value;

      // Filter out new jobs count for viewed queries

      return history.map((item) => ({

        ...item,

        new_jobs_count: viewedQueries.value.has(item.query)

          ? 0

          : item.new_jobs_count,

      }));

    });



    const fetchSearchHistory = async (fetchAll = false) => {

      if (!authStore.state.isLoggedIn) return;



      try {

        const limit = fetchAll ? 100 : 3;

        const response = await apiClient.get("/jobseeker/search/history/", {

          params: { limit },

        });



        const data = response.data?.results || [];



        if (fetchAll) {

          allSearchHistory.value = data;

          totalSearchHistoryCount.value = data.length;


        } else {

          searchHistory.value = data;

          // "See more" when we have a full recent page (loaded on demand via handleSeeMore)

          totalSearchHistoryCount.value = data.length;


        }



        searchHistoryLoaded.value = true;

      } catch (error) {

        console.error("Failed to fetch search history:", error);

        if (fetchAll) {

          allSearchHistory.value = [];

          totalSearchHistoryCount.value = 0;

        } else {

          searchHistory.value = [];

          totalSearchHistoryCount.value = 0;

        }

        searchHistoryLoaded.value = true;

      }

    };



    const onSearchFocus = async () => {

      if (!authStore.state.isLoggedIn) return;



      // Clear any existing timer

      if (hideSearchHistoryTimer) {

        clearTimeout(hideSearchHistoryTimer);

        hideSearchHistoryTimer = null;

      }



      // Load recent history if not loaded

      if (!searchHistoryLoaded.value) {

        await fetchSearchHistory(false);

      }



      // Show dropdown with recent history

      showSearchHistoryDropdown.value = true;

      showFullHistory.value = false;


    };



    const onSearchBlur = () => {

      // Delay hide so clicks on dropdown register

      hideSearchHistoryTimer = setTimeout(() => {

        showSearchHistoryDropdown.value = false;


      }, 300); // Increased to 300ms for better reliability

    };



    let activeSearchAbortController = null;



    const cancelActiveSearch = () => {

      if (!activeSearchAbortController) return;

      try {

        activeSearchAbortController.abort();

      } catch (e) {

        // ignore

      } finally {

        activeSearchAbortController = null;

      }

    };



    /** Typing only updates the query + search history UI — no API search until Search Jobs or Enter. */

    const onSearchInput = () => {

      // Search history dropdown is only for logged-in users

      if (!authStore.state.isLoggedIn) return;



      // Show dropdown when typing

      showSearchHistoryDropdown.value = true;

      showFullHistory.value = false;



      // Load history if empty and not loaded

      if (!searchQuery.value.trim() && !searchHistoryLoaded.value) {

        fetchSearchHistory(false);

      }




    };



    const selectSearchHistory = async (query) => {

      searchQuery.value = query || "";

      showSearchHistoryDropdown.value = false;



      // Mark this query as viewed

      viewedQueries.value.add(query);

      saveViewedQueries(); // Save to localStorage



      // Mark search history as viewed (optional - call API if available)

      try {

        await apiClient.post(`/jobseeker/search/history/mark-viewed/`, {

          query: query,

        });

      } catch (error) {

        // API might not exist yet, but that's okay


      }



      await searchJobs(false);

      // Record as a search (searchJobs(false) skips history recording)

      if (authStore.state.isLoggedIn && (query || "").trim()) {

        searchHistoryLoaded.value = false;

        apiClient

          .post("/jobseeker/search/record/", {

            query: String(query).trim(),

            filters: {

              jobType: filters.value.jobType,

              datePosted: filters.value.datePosted,

              source: filters.value.source,

              tags: selectedTags.value,

              includeDescription: true,

            },

          })

          .catch((err) => {

            console.error("Failed to record job search history:", err);

          });

      }




    };



    const deleteSearchHistoryItem = async (query) => {

      if (!query) return;



      try {

        await apiClient.delete(`/jobseeker/search/history/delete/`, {

          params: { q: query },

        });



        // Remove from both arrays

        searchHistory.value = searchHistory.value.filter(

          (item) => item.query !== query,

        );

        allSearchHistory.value = allSearchHistory.value.filter(

          (item) => item.query !== query,

        );



        // If showing all history and no items left, close dropdown

        if (showFullHistory.value && allSearchHistory.value.length === 0) {

          showSearchHistoryDropdown.value = false;

          showFullHistory.value = false;

        }

        // If showing recent history, refresh to maintain items

        else if (!showFullHistory.value) {

          setTimeout(() => fetchSearchHistory(false), 200); // Reduced delay for smoother

        }




      } catch (error) {

        console.error("Failed to delete search history item:", error);

      }

    };



    const handleSeeMore = async (event) => {

      // Prevent dropdown from closing

      event.preventDefault();

      event.stopPropagation();






      // Clear any existing blur timer immediately

      if (hideSearchHistoryTimer) {

        clearTimeout(hideSearchHistoryTimer);

        hideSearchHistoryTimer = null;

      }



      try {

        // Fetch all history

        await fetchSearchHistory(true);



        // Show full history

        showFullHistory.value = true;



        // Force dropdown to stay open

        showSearchHistoryDropdown.value = true;




      } catch (error) {

        console.error("Failed to show all history:", error);

      }

    };



    const handleHide = (event) => {

      // Prevent dropdown from closing

      event.preventDefault();

      event.stopPropagation();






      // Clear any existing blur timer

      if (hideSearchHistoryTimer) {

        clearTimeout(hideSearchHistoryTimer);

        hideSearchHistoryTimer = null;

      }



      // Show recent history only

      showFullHistory.value = false;



      // Force dropdown to stay open

      showSearchHistoryDropdown.value = true;




    };



    const handleClearAll = async (event) => {

      // Prevent dropdown from closing

      event.preventDefault();

      event.stopPropagation();



      // Clear any existing blur timer

      if (hideSearchHistoryTimer) {

        clearTimeout(hideSearchHistoryTimer);

        hideSearchHistoryTimer = null;

      }






      try {

        await apiClient.delete("/jobseeker/search/history/clear-all/");



        // Clear both arrays

        searchHistory.value = [];

        allSearchHistory.value = [];



        // Reset state

        showFullHistory.value = false;

        showSearchHistoryDropdown.value = false;




      } catch (error) {

        console.error("Failed to clear search history:", error);

        // Show error message to user

        alert("Failed to clear search history. Please try again.");

      }

    };



    // NEW: flag to skip the route-query watcher when viewAllJobs navigates

    const skipRouteQueryWatch = ref(false);



    const getJobDetailPath = (jobItem) => {

      if (!jobItem) {

        return buildJobDetailsPath("", "");

      }

      const id =

        jobItem.id ??

        jobItem.job_id ??

        jobItem.job?.id ??

        jobItem.job_details?.id;

      const title =

        jobItem.title ??

        jobItem.job_title ??

        jobItem.job?.title ??

        jobItem.job_details?.title;

      return buildJobDetailsPath(title, id);

    };



    const handleJobCardClick = (jobItem) => {

      if (!jobItem) return;

      router.push({

        path: getJobDetailPath(jobItem),

        query: route.query,

      });

    };



    // Pagination

    const currentPage = ref(1);

    const itemsPerPage = ref(20); // Items shown per page (client-side pagination)

    const MAX_FETCH = 100; // Always fetch at most 100 jobs per request

    const totalPages = computed(() => {

      return Math.ceil(jobs.value.length / itemsPerPage.value);

    });



    // Calculate displayed pages for pagination

    const displayedPages = computed(() => {

      const pages = [];

      const maxVisiblePages = 5;



      if (totalPages.value <= maxVisiblePages) {

        for (let i = 1; i <= totalPages.value; i++) {

          pages.push(i);

        }

      } else {

        // Always show first page

        pages.push(1);



        let startPage = Math.max(2, currentPage.value - 1);

        let endPage = Math.min(totalPages.value - 1, currentPage.value + 1);



        // Adjust if we're near the beginning

        if (currentPage.value <= 3) {

          endPage = 4;

        }



        // Adjust if we're near the end

        if (currentPage.value >= totalPages.value - 2) {

          startPage = totalPages.value - 3;

        }



        // Add ellipsis if needed

        if (startPage > 2) {

          pages.push("...");

        }



        // Add middle pages

        for (let i = startPage; i <= endPage; i++) {

          pages.push(i);

        }



        // Add ellipsis if needed

        if (endPage < totalPages.value - 1) {

          pages.push("...");

        }



        // Always show last page

        pages.push(totalPages.value);

      }



      return pages;

    });



    // Filters

    const DEFAULT_LISTING_SOURCE = "";
    // 'olj' is excluded unless the admin has enabled it for this user (olj_jobs_enabled).
    const oljUnlocked = computed(() => !!authStore.state.user?.olj_jobs_enabled);
    const BASE_LISTING_SOURCES = ["jobstreet", "cloudstaff", "emapta", "bossjob", "kalibrr", "VAWorkersPH", "findtalent", "hiretalent", "ofmjobs", "upwork"];
    const listingSources = () => new Set(oljUnlocked.value ? [...BASE_LISTING_SOURCES, "olj"] : BASE_LISTING_SOURCES);
    const allowedListingSources = () => Array.from(listingSources()).join(",");
    // When no specific source is picked ("All Sources"), explicitly scope to the
    // allowed sources so hidden/locked OLJ jobs don't leak into the default results.
    const applySourceParams = (target) => {
      if (filters.value.source) {
        target.source = filters.value.source;
      } else {
        target.sources = allowedListingSources();
      }
    };



    const filters = ref({

      jobType: "",

      datePosted: "",

      source: DEFAULT_LISTING_SOURCE,

      similarToJobId: null,

    });



    // Tags

    const popularTags = ref([]);

    const selectedTags = ref([]);

    const tagInput = ref("");



    // Sorting

    const sortBy = ref("date_desc");



    // Add a state variable to track if we're viewing similar jobs

    const isViewingSimilarJobs = ref(false);



    // OLJ connection status

    const userHasOljConnection = ref(false);



    const numberFormatter = new Intl.NumberFormat('en-US');

    const formatNumber = (value) => {

      const n = Number(value);

      return Number.isFinite(n) ? numberFormatter.format(n) : '0';

    };



    // Computed property to get the displayed jobs with pagination

    const displayedJobs = computed(() => {

      const hiddenJobIds = store.getters["hiddenJobs/hiddenJobIds"];

      const visibleJobs = Array.isArray(jobs.value)

        ? jobs.value.filter((job) => job && !hiddenJobIds.includes(job.id))

        : [];

      const startIndex = (currentPage.value - 1) * itemsPerPage.value;

      const endIndex = startIndex + itemsPerPage.value;

      return visibleJobs.slice(startIndex, endIndex);

    });



    // Computed property for results heading

    const resultsHeading = computed(() => {

      // If we're viewing similar jobs

      if (isViewingSimilarJobs.value || filters.value.similarToJobId) {

        return `${formatNumber(totalJobs.value)} similar jobs found`;

      }



      // If we have a search query

      if (searchQuery.value.trim()) {

        return `Jobs matching "${searchQuery.value}"`;

      }



      // Default case for all jobs or filtered results without search term

      return jobs.value.length > 0

        ? "Jobs Found"

        : "Start your search";

    });



    // Computed property to check if a job is saved

    const isJobSaved = (jobId) => {

      return store.getters["savedJobs/isJobSaved"](jobId);

    };



    // Computed property to check if a job is hidden

    const isJobHidden = (jobId) => {

      return store.getters["hiddenJobs/isJobHidden"](jobId);

    };



    // Fetch all jobs from the API

    const fetchJobs = async () => {

      loading.value = true;

      error.value = null;



      cancelActiveSearch();

      activeSearchAbortController = new AbortController();

      // Reset search query and filters when fetching all jobs

      searchQuery.value = "";

      resetFilters();

      currentPage.value = 1; // Always reset to first page

      try {

        const searchParams = {

          page: 1,

          per_page: MAX_FETCH,

          sort_by: sortBy.value,

        };

        applySourceParams(searchParams);

        const response = await apiClient.get("/jobs/search/", {

          params: searchParams,

        });


        jobs.value = response.data.results;

        totalJobs.value = response.data.count;

        applySorting(jobs.value);

      } catch (err) {

        console.error("Error fetching jobs:", err);

        error.value = "Failed to load jobs. Please try again.";

      } finally {

        loading.value = false;

        hasInitialLoad.value = true;

      }

    };



    const refreshJobsList = async () => {

      if (loading.value) return;



      if (isViewingSimilarJobs.value && filters.value.similarToJobId) {

        await fetchSimilarJobs(filters.value.similarToJobId);

        return;

      }



      if (hasQueryParams()) {

        await searchJobs(false);

        return;

      }



      loading.value = true;

      error.value = null;

      try {

        const searchParams = {

          page: 1,

          per_page: MAX_FETCH,

          sort_by: sortBy.value,

        };

        applySourceParams(searchParams);

        const res = await apiClient.get("/jobs/search/", {

          params: searchParams,

        });

        jobs.value = res.data.results;

        totalJobs.value = res.data.count;

        applySorting(jobs.value);

      } catch (err) {

        console.error("Error refreshing jobs:", err);

        error.value = "Failed to refresh jobs. Please try again.";

      } finally {

        loading.value = false;

        hasInitialLoad.value = true;

      }

    };



    // Check OLJ connection status

    const checkOljConnection = async () => {

      if (!authStore.state.isLoggedIn) {

        userHasOljConnection.value = false;

        return;

      }



      try {

        const response = await apiClient.get("/settings/integrations/");

        const integrationsData = response.data;



        if (integrationsData) {

          // Check if olj_email exists in the response (backward compatibility format)

          if ("olj_email" in integrationsData) {

            userHasOljConnection.value = !!integrationsData.olj_email;

          }

          // Also check the new format with integrations array

          else if (

            integrationsData.integrations &&

            Array.isArray(integrationsData.integrations)

          ) {

            const oljIntegration = integrationsData.integrations.find(

              (i) => i.type === "olj",

            );

            userHasOljConnection.value = !!oljIntegration;

          } else {

            userHasOljConnection.value = false;

          }

        } else {

          userHasOljConnection.value = false;

        }

      } catch (err) {


        userHasOljConnection.value = false;

      }

    };



    // Load initial data


    onMounted(async () => {

      // Load viewed queries from localStorage

      loadViewedQueries();



      // Always load state from URL query parameters on mount

      loadFromQueryParams();



      // JobsListing mounts before App.vue runs checkAuthStatus(); sync session first.

      await authStore.checkAuthStatus();



      // Fetch popular tags for filtering

      await fetchPopularTags();



      if (authStore.state.isLoggedIn) {

        await checkOljConnection();

      } else {

        userHasOljConnection.value = false;

      }



      // Only fetch saved jobs if user is logged in

      if (authStore.state.isLoggedIn) {

        store.dispatch("savedJobs/fetchSavedJobs");

        store.dispatch("hiddenJobs/fetchHiddenJobs");

      } else {

        // Clear saved jobs when not logged in

        store.commit("savedJobs/SET_SAVED_JOBS", []);

        store.commit("hiddenJobs/SET_HIDDEN_JOBS", []);

      }



      // Determine what to do based on query params

      if (route.query.similar_to) {

        filters.value.similarToJobId = route.query.similar_to;

        isViewingSimilarJobs.value = true;

        await fetchSimilarJobs(route.query.similar_to);

      } else if (Object.keys(route.query).length > 0) {

        // Query params already applied via loadFromQueryParams() at start of onMounted

        searchJobs(false);

      } else {

        // No URL params — try to restore filter state from sessionStorage
        let restoredFilters = false;
        try {
          const raw = sessionStorage.getItem('jobsListingState');
          if (raw) {
            const saved = JSON.parse(raw);
            if (Date.now() - saved.timestamp < 10 * 60 * 1000) {
              // Re-add custom tags so their names display correctly
              if (saved.customTags && saved.customTags.length) {
                saved.customTags.forEach((ct) => {
                  if (!popularTags.value.find((t) => t.id === ct.id)) {
                    popularTags.value.push({ ...ct, isCustom: true });
                  }
                });
              }
              if (saved.selectedTagIds && saved.selectedTagIds.length) {
                selectedTags.value = saved.selectedTagIds;
                restoredFilters = true;
              }
              if (saved.searchQuery) {
                searchQuery.value = saved.searchQuery;
                restoredFilters = true;
              }
              if (saved.jobType) filters.value.jobType = saved.jobType;
              if (saved.source) filters.value.source = saved.source;
              if (saved.sortBy) sortBy.value = saved.sortBy;
            }
          }
        } catch {
          // ignore
        }

        if (restoredFilters) {
          searchJobs(false);
        } else {
          viewAllJobs();
        }

      }



      // onboarding prompt hidden

    });



    onBeforeUnmount(() => {

      isMounted.value = false;

      cancelActiveSearch();

      // Save scroll position and filter state so back-navigation can restore them
      sessionStorage.setItem('jobsListingState', JSON.stringify({
        scrollY: window.scrollY,
        page: currentPage.value,
        timestamp: Date.now(),
        selectedTagIds: selectedTags.value,
        customTags: popularTags.value
          .filter((t) => t.isCustom)
          .map((t) => ({ id: t.id, name: t.name })),
        searchQuery: searchQuery.value,
        jobType: filters.value.jobType,
        source: filters.value.source,
        sortBy: sortBy.value,
      }));

    });

    // Restore scroll position when navigating back from a job detail page
    watch(hasInitialLoad, (loaded) => {
      if (!loaded) return;
      const raw = sessionStorage.getItem('jobsListingState');
      if (!raw) return;
      try {
        const { scrollY, page, timestamp } = JSON.parse(raw);
        // Only restore if saved within the last 10 minutes
        if (Date.now() - timestamp < 10 * 60 * 1000) {
          currentPage.value = page || 1;
          nextTick(() => {
            setTimeout(() => window.scrollTo({ top: scrollY, behavior: 'instant' }), 80);
          });
        }
      } catch (e) { /* ignore */ } finally {
        sessionStorage.removeItem('jobsListingState');
      }
    });



    // Watch for route changes

    watch(

      () => route.query,

      (newQuery, oldQuery) => {

        // NEW: if navigation was triggered by viewAllJobs, just clear the flag and skip

        if (skipRouteQueryWatch.value) {

          skipRouteQueryWatch.value = false;

          return;

        }



        // Skip processing if this is a self-triggered update from searchJobs

        // Compare old and new queries to avoid redundant processing

        const sameSearchTerm =

          newQuery.q === oldQuery.q && newQuery.search === oldQuery.search;

        const sameTags = (newQuery.tags || "") === (oldQuery.tags || "");



        // Only process if the search term actually changed or if it's a completely different query type

        if (

          !sameSearchTerm ||

          !sameTags ||

          (newQuery.similar_to && !oldQuery.similar_to) ||

          (!newQuery.similar_to && oldQuery.similar_to)

        ) {

          if (newQuery.similar_to) {

            // If we have a similar_to parameter, fetch similar jobs

            filters.value.similarToJobId = newQuery.similar_to;

            isViewingSimilarJobs.value = true;

            fetchSimilarJobs(newQuery.similar_to);

          } else if (Object.keys(newQuery).length > 0) {

            // Regular search with query parameters

            isViewingSimilarJobs.value = false;

            loadFromQueryParams();

            // Pass false to searchJobs to prevent double counting

            // because this was triggered by a router.push from searchJobs itself

            searchJobs(false);

          } else {

            // No query parameters, just fetch all jobs

            isViewingSimilarJobs.value = false;

            fetchJobs();

          }

        }

      },

    );



    // Watch for sort changes - only apply when not viewing similar jobs

    watch(sortBy, () => {

      if (!isViewingSimilarJobs.value && jobs.value.length > 0) {

        if (hasQueryParams()) {

          searchJobs(false); // Use false to avoid incrementing search count

        } else {

          // For view all jobs scenario, we need to re-fetch with sorting

          viewAllJobs();

        }

      }

    });



    // Load search parameters from URL query

    const loadFromQueryParams = () => {

      const query = route.query;



      // Check if we're viewing similar jobs

      if (query.similar_to) {

        filters.value.similarToJobId = query.similar_to;

        isViewingSimilarJobs.value = true;

        return; // Don't load other params when viewing similar jobs

      } else {

        isViewingSimilarJobs.value = false;

      }



      // If we have no query params or only have similar_to param (not search/q param)

      // then reset the search query

      if (

        Object.keys(query).length === 0 ||

        (query.similar_to && !query.q && !query.search)

      ) {

        searchQuery.value = "";

      } else {

        // Set search query from either q or search parameter

        searchQuery.value = query.q || query.search || "";

      }



      filters.value.jobType = query.job_type || "";

      filters.value.datePosted = query.date_posted || "";

      const urlSource = query.source;

      if (listingSources().has(urlSource)) {

        filters.value.source = urlSource;

      } else if (urlSource === "" || urlSource === "all") {

        filters.value.source = "";

      } else {

        filters.value.source = DEFAULT_LISTING_SOURCE;

      }

      filters.value.similarToJobId = query.similar_to || null;

      sortBy.value = query.sort_by || "date_desc";

      currentPage.value = parseInt(query.page || "1");



      // Handle tags — always rebuild from URL so we never stack duplicates
      // when loadFromQueryParams runs again after searchJobs updates the route.

      if (query.tags) {

        selectedTags.value = [];

        const tagParams = query.tags.split(",");



        // Process each tag parameter

        tagParams.forEach((tagParam) => {

          // Custom tag with name:value format

          if (tagParam.startsWith("name:")) {

            // Properly decode the tag name to handle spaces and special characters

            const tagName = decodeURIComponent(tagParam.substring(5));

            // Check if this tag already exists

            let tag = popularTags.value.find(

              (t) => t.name.toLowerCase() === tagName.toLowerCase(),

            );



            if (!tag) {

              // Create a new custom tag

              tag = {

                id: -Date.now() - Math.floor(Math.random() * 1000), // Negative ID to ensure uniqueness

                name: tagName,

                isCustom: true,

              };

              popularTags.value.push(tag);

            }



            // Add to selected tags if not already there

            if (!selectedTags.value.includes(tag.id)) {

              selectedTags.value.push(tag.id);

            }

          }

          // Regular tag ID

          else if (tagParam.match(/^-?\d+$/)) {

            const tid = parseInt(tagParam, 10);

            if (!selectedTags.value.includes(tid)) {

              selectedTags.value.push(tid);

            }

          }

        });

      } else {

        selectedTags.value = [];

      }

    };



    // Check if we have query parameters

    const hasQueryParams = () => {

      return Object.keys(route.query).length > 0;

    };



    // Fetch popular tags for filtering

    const fetchPopularTags = async () => {

      try {

        const response = await apiClient.get("/tags/popular/");

        const customTags = popularTags.value.filter((t) => t.isCustom);

        popularTags.value = [...response.data, ...customTags];

      } catch (error) {

        console.error("Error fetching popular tags:", error);

        // Sample data for development

        popularTags.value = [

          { id: 1, name: "JavaScript" },

          { id: 2, name: "Python" },

          { id: 3, name: "React" },

          { id: 4, name: "Django" },

          { id: 5, name: "Vue.js" },

          { id: 6, name: "Remote" },

          { id: 7, name: "Frontend" },

          { id: 8, name: "Backend" },

          { id: 9, name: "Full Stack" },

          { id: 10, name: "DevOps" },

        ];

      }

    };



    // Fetch similar jobs

    const fetchSimilarJobs = async (jobId) => {

      loading.value = true;

      error.value = null;

      isViewingSimilarJobs.value = true;



      try {

        // First attempt to get the job details to have more context

        const jobDetailsResponse = await apiClient.get(`/jobs/${jobId}/`);

        const jobDetails = jobDetailsResponse.data;



        // Don't set search query when viewing similar jobs

        // searchQuery.value = jobDetails.title;



        // Try the direct similar jobs endpoint first

        const response = await apiClient.get(`/jobs/${jobId}/similar/`);

        let similarJobsResults = response.data || [];



        // Keep track of all jobs we've found and their sources for debugging




        // If we don't have enough similar jobs, try to find more with tag matching

        if (similarJobsResults.length < 10 && jobDetails) {

          // Get the job's tags

          const jobTags = jobDetails.tags || [];

          const tagIds = jobTags.map((tag) => tag.id).join(",");



          // Get more jobs with matching tags if available

          if (tagIds) {


            const tagBasedResponse = await apiClient.get(`/jobs/`, {

              params: { tags: tagIds },

            });



            // Filter out the current job and already found similar jobs

            const additionalTagJobs = (

              tagBasedResponse.data.results ||

              tagBasedResponse.data ||

              []

            ).filter(

              (job) =>

                job.id !== parseInt(jobId) &&

                !similarJobsResults.some((sj) => sj.id === job.id),

            );






            // Calculate similarity scores for ranking

            additionalTagJobs.forEach((job) => {

              job.similarityScore = calculateSimilarityScore(job, jobDetails);

              job.similaritySource = "tags";

            });



            // Sort by similarity score and take the most relevant ones

            additionalTagJobs.sort(

              (a, b) => b.similarityScore - a.similarityScore,

            );

            const mostRelevantTagJobs = additionalTagJobs.slice(0, 10);



            // Combine with the direct similar jobs

            similarJobsResults = [

              ...similarJobsResults,

              ...mostRelevantTagJobs,

            ];

          }



          // If we still need more jobs, try with job type

          if (similarJobsResults.length < 10 && jobDetails.job_type) {


            const jobTypeResponse = await apiClient.get(`/jobs/`, {

              params: { job_type: jobDetails.job_type },

            });



            // Filter out the current job and already found similar jobs

            const jobTypeJobs = (

              jobTypeResponse.data.results ||

              jobTypeResponse.data ||

              []

            ).filter(

              (job) =>

                job.id !== parseInt(jobId) &&

                !similarJobsResults.some((sj) => sj.id === job.id),

            );






            // Calculate similarity scores for all job type matches

            jobTypeJobs.forEach((job) => {

              job.similarityScore = calculateSimilarityScore(job, jobDetails);

              job.similaritySource = "jobType";

            });



            // Sort by similarity score and take the top ones

            jobTypeJobs.sort((a, b) => b.similarityScore - a.similarityScore);

            const mostRelevantJobTypeJobs = jobTypeJobs.slice(0, 5);



            // Add to our results

            similarJobsResults = [

              ...similarJobsResults,

              ...mostRelevantJobTypeJobs,

            ];

          }



          // If still not enough, try with title keywords

          if (similarJobsResults.length < 10 && jobDetails.title) {

            // Extract meaningful keywords from the job title

            const titleKeywords = jobDetails.title

              .split(/\s+/)

              .filter(

                (word) =>

                  word.length > 3 &&

                  !["and", "the", "for", "with"].includes(word.toLowerCase()),

              )

              .join(" ");



            if (titleKeywords) {


              const titleBasedResponse = await apiClient.get("/jobs/", {

                params: { search: titleKeywords, sources: allowedListingSources() },

              });



              // Filter out the current job and already found similar jobs

              const titleJobs = (

                titleBasedResponse.data.results ||

                titleBasedResponse.data ||

                []

              ).filter(

                (job) =>

                  job.id !== parseInt(jobId) &&

                  !similarJobsResults.some((sj) => sj.id === job.id),

              );






              // Calculate similarity scores

              titleJobs.forEach((job) => {

                job.similarityScore = calculateSimilarityScore(job, jobDetails);

                job.similaritySource = "title";

              });



              // Sort by similarity score and take the top ones

              titleJobs.sort((a, b) => b.similarityScore - a.similarityScore);

              const mostRelevantTitleJobs = titleJobs.slice(0, 5);



              // Add to our results

              similarJobsResults = [

                ...similarJobsResults,

                ...mostRelevantTitleJobs,

              ];

            }

          }

        }



        // Last resort: if we still don't have enough jobs, get latest jobs

        if (similarJobsResults.length < 5) {


          const latestJobsResponse = await apiClient.get(`/jobs/`);



          // Filter out the current job and already found similar jobs

          const latestJobs = (

            latestJobsResponse.data.results ||

            latestJobsResponse.data ||

            []

          )

            .filter(

              (job) =>

                job.id !== parseInt(jobId) &&

                !similarJobsResults.some((sj) => sj.id === job.id),

            )

            .slice(0, 5);






          // Add similarity score (will be lower by default)

          latestJobs.forEach((job) => {

            job.similarityScore = calculateSimilarityScore(job, jobDetails) / 2; // Lower score for random jobs

            job.similaritySource = "latest";

          });



          similarJobsResults = [...similarJobsResults, ...latestJobs];

        }



        // Final sort by similarity score

        similarJobsResults.sort((a, b) => {

          // First prioritize jobs with similarity scores

          if (a.similarityScore && !b.similarityScore) return -1;

          if (!a.similarityScore && b.similarityScore) return 1;

          // Then sort by the score

          return (b.similarityScore || 0) - (a.similarityScore || 0);

        });






        // Enhance the jobs with similarity labels

        similarJobsResults = similarJobsResults.map((job) => {

          if (job.similarityScore) {

            job.similarityLabel = getSimilarityLabel(job.similarityScore);

          }

          return job;

        });



        // Update our jobs and total count

        jobs.value = similarJobsResults;

        totalJobs.value = similarJobsResults.length;



        // Update URL to maintain similar_to parameter but remove other search parameters

        router.replace({

          path: "/jobs",

          query: { similar_to: jobId },

        });

      } catch (err) {

        console.error("Error fetching similar jobs:", err);

        error.value = "Failed to find similar jobs. Showing all jobs instead.";



        // Fallback to all jobs as a last resort

        await fetchJobs();

      } finally {

        loading.value = false;

        hasInitialLoad.value = true;

      }

    };



    // Calculate similarity score between two jobs - enhance this for better accuracy

    const calculateSimilarityScore = (job, referenceJob) => {

      let score = 0;



      // Title similarity (highest weight)

      if (job.title && referenceJob.title) {

        const titleWords = referenceJob.title.toLowerCase().split(/\s+/);

        const jobTitleLower = job.title.toLowerCase();



        let titleMatches = 0;

        titleWords.forEach((word) => {

          if (word.length > 3 && jobTitleLower.includes(word)) {

            titleMatches++;

            score += 3;

          }

        });



        // Bonus for high percentage of matching words

        if (titleMatches > 0) {

          const matchPercentage = titleMatches / titleWords.length;

          if (matchPercentage > 0.5) {

            score += 5; // Significant title overlap

          }

        }



        // Extra bonus for exact title match or very close match

        if (jobTitleLower === referenceJob.title.toLowerCase()) {

          score += 10; // Exact match

        } else if (

          jobTitleLower.includes(referenceJob.title.toLowerCase()) ||

          referenceJob.title.toLowerCase().includes(jobTitleLower)

        ) {

          score += 5; // One title contains the other

        }

      }



      // Tag matches (important for skill matching)

      const refTagIds = (referenceJob.tags || []).map((tag) => tag.id);

      const jobTagIds = (job.tags || []).map((tag) => tag.id);



      let tagMatches = 0;

      jobTagIds.forEach((tagId) => {

        if (refTagIds.includes(tagId)) {

          tagMatches++;

          score += 2;

        }

      });



      // Bonus for high percentage of matching tags

      if (tagMatches > 0 && refTagIds.length > 0) {

        const matchPercentage = tagMatches / refTagIds.length;

        if (matchPercentage > 0.7) {

          score += 7; // Very similar tag profile

        } else if (matchPercentage > 0.5) {

          score += 4; // Moderately similar tag profile

        }

      }



      // Job type match

      if (job.job_type === referenceJob.job_type) {

        score += 2;

      }



      // Employer match (might be same company, different role)

      if (job.employer?.id === referenceJob.employer?.id) {

        score += 3;

      }



      // Salary range similarity (if available)

      if (job.salary && referenceJob.salary) {

        // Simple check if salary strings have overlap

        if (

          job.salary.includes(referenceJob.salary) ||

          referenceJob.salary.includes(job.salary)

        ) {

          score += 1;

        }

      }



      return score;

    };



    // Get similarity label based on score

    const getSimilarityLabel = (score) => {

      if (score >= 12) return "Highly Similar";

      if (score >= 8) return "Very Similar";

      if (score >= 4) return "Similar";

      return "Related";

    };



    // Helper function to detect job source from URL

    const detectJobSource = (url) => {

      const urlLower = url.toLowerCase();

      if (urlLower.includes("linkedin.com") && urlLower.includes("/jobs")) {

        return "linkedin";

      } else if (urlLower.includes("onlinejobs.ph")) {

        return "olj";

      }

      return null;

    };



    // Helper function to normalize URL - handles both full URLs and partial IDs

    const normalizeJobUrl = (input) => {

      const trimmed = input.trim();



      // If it's already a full URL, return it as-is

      if (trimmed.startsWith("http://") || trimmed.startsWith("https://")) {

        return trimmed;

      }



      // Try to detect source from the input

      const source = detectJobSource(trimmed);



      // Extract ID from various formats

      let id = null;

      if (trimmed.includes("-")) {

        id = trimmed.split("-").pop();

      } else if (trimmed.includes("/")) {

        id = trimmed.split("/").pop();

      } else {

        // If it's just a number or alphanumeric, assume it's an ID

        id = trimmed;

      }



      if (!id) return null;



      // Construct URL based on detected source or default to OnlineJobs

      if (source === "linkedin") {

        // If it looks like a LinkedIn URL pattern, construct it

        if (trimmed.includes("linkedin.com")) {

          return trimmed; // Already a full LinkedIn URL

        }

        // For LinkedIn, we need the full URL - can't reconstruct from just ID

        // So return null to indicate we need the full URL

        return null;

      } else {

        // Default to OnlineJobs format

        return `https://www.onlinejobs.ph/jobseekers/job/${id}`;

      }

    };



    // Clear search function

    const clearSearch = () => {

      searchQuery.value = "";

      showSearchHistoryDropdown.value = false;

      // Optionally trigger search to show all jobs

      searchJobs(false, "replace");

    };



    // Main search function

    const searchJobs = async (isInitialSearch = true, urlMode = "push") => {

      showSearchHistoryDropdown.value = false;



      cancelActiveSearch();

      activeSearchAbortController = new AbortController();



      // Prevent an empty manual search

      if (isInitialSearch && !searchQuery.value.trim()) {

        toastType.value = "warning";

        toastTitle.value = "Empty Search";

        toastMessage.value = "Please enter a search term.";

        showToast.value = true;

        setTimeout(() => {

          showToast.value = false;

        }, 3000);

        return;

      }



      // Check if the search query is a URL (starts with http) or looks like a job URL/ID

      const searchInput = searchQuery.value.trim();

      const isUrl =

        searchInput.startsWith("http://") || searchInput.startsWith("https://");

      const isLikelyJobUrl =

        isUrl || searchInput.match(/^(linkedin\.com|onlinejobs\.ph|\d+)/i);



      if (isLikelyJobUrl) {

        let jobUrl = null;



        // If it's already a full URL, use it directly

        if (isUrl) {

          jobUrl = searchInput;

        } else {

          // Try to normalize/construct the URL

          jobUrl = normalizeJobUrl(searchInput);



          // If we couldn't normalize it and it's not a full URL, show error for LinkedIn

          if (!jobUrl && detectJobSource(searchInput) === "linkedin") {

            toastType.value = "error";

            toastTitle.value = "Invalid URL";

            toastMessage.value =

              "Please provide the full LinkedIn job URL (e.g., https://www.linkedin.com/jobs/view/...)";

            showToast.value = true;

            setTimeout(() => {

              showToast.value = false;

            }, 4000);

            return;

          }

        }



        if (!jobUrl) {

          toastType.value = "error";

          toastTitle.value = "Invalid URL";

          toastMessage.value =

            "Could not process the job URL. Please provide a full URL.";

          showToast.value = true;

          setTimeout(() => {

            showToast.value = false;

          }, 3000);

          return;

        }






        // Show loading toast

        toastType.value = "info";

        toastTitle.value = "Loading";

        toastMessage.value = "Scraping job information, please wait...";

        showToast.value = true;



        try {

          const { data } = await apiClient.post("/job-id-from-url/", {

            url: jobUrl,

          });




          // Hide loading toast and navigate

          showToast.value = false;

          router.push(buildJobDetailsPath(data.job_title, data.job_id));

        } catch (error) {

          console.error("Error fetching job ID from URL:", error);

          // Hide loading toast and show error

          showToast.value = false;

          toastType.value = "error";

          toastTitle.value = "Error";

          const errorMessage =

            error.response?.data?.message ||

            error.response?.data?.error ||

            "Failed to fetch job ID from URL. Please verify the URL is correct and try again.";

          toastMessage.value = errorMessage;

          showToast.value = true;

          setTimeout(() => {

            showToast.value = false;

          }, 4000);

        }

        return;

      }



      // Don't run search if viewing similar jobs

      if (isViewingSimilarJobs.value) {

        return;

      }



      // A fresh keyword search should always start from page 1
      if (isInitialSearch) {

        currentPage.value = 1;

      }



      loading.value = true;

      error.value = null;



      // Clear similarToJobId when doing a regular search

      filters.value.similarToJobId = null;

      isViewingSimilarJobs.value = false;



      // Build query parameters — always fetch MAX_FETCH at once for client-side pagination

      const params = {

        page: 1,

        per_page: MAX_FETCH,

        sort_by: sortBy.value, // Ensure sort parameter is included

      };



      // Add search query parameter only if it's not empty

      if (searchQuery.value.trim()) {
        params.search = searchQuery.value.trim();

        // Only enable deep description search for multi-word queries where all words are meaningful.
        // Short/generic words (web, app, dev, etc.) should only match title and tags to avoid
        // irrelevant results where the word appears incidentally in a job description.
        const queryWords = searchQuery.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
        const SHORT_SKIP = new Set(['web', 'app', 'it', 'hr', 'ai', 'ui', 'ux', 'qa', 'dev',
          'api', 'sql', 'php', 'css', 'aws', 'crm', 'erp', 'the', 'and', 'for']);
        const hasShortOrSkipWord = queryWords.some(w => w.length <= 3 || SHORT_SKIP.has(w));

        if (queryWords.length > 1 && !hasShortOrSkipWord) {
          params.deep_search = "1";
        }
      }



      // Add filters if they're set

      if (filters.value.jobType) {

        params.job_type = filters.value.jobType;

      }



      if (filters.value.datePosted) {

        params.date_posted = filters.value.datePosted;

      }



      applySourceParams(params);



      // Add tags if any are selected

      if (selectedTags.value.length > 0) {

        // Process tags - handle custom tags (negative IDs) differently

        const uniqueTagSelection = [...new Set(selectedTags.value)];

        const tagParams = uniqueTagSelection.map((tagId) => {

          const tag = popularTags.value.find((t) => t.id === tagId);

          // For custom tags (negative IDs), send name:tagname format

          if (tag && tag.id < 0) {

            // Fully encode the tag name to handle spaces and special characters

            return `name:${encodeURIComponent(tag.name)}`;

          }

          // Otherwise just send the ID

          return tagId;

        });

        params.tags = tagParams.join(",");

        selectedTags.value = uniqueTagSelection;

      }



      // Update URL with q parameter for backwards compatibility

      const urlParams = { ...params };

      if (params.search) {

        urlParams.q = params.search;

        delete urlParams.search;

      }



      // Do not persist source or internal pagination params in the URL.

      delete urlParams.source;

      delete urlParams.page;

      delete urlParams.per_page;



      const nav = {

        path: "/jobs",

        query: urlParams,

      };

      // Prevent route.query watcher from running loadFromQueryParams + a second searchJobs

      skipRouteQueryWatch.value = true;

      if (urlMode === "replace") {

        router.replace(nav);

      } else {

        router.push(nav);

      }



      try {

        // First try the search endpoint

        let response;






        try {

          const requestConfig = {

            params,

          };

          if (activeSearchAbortController) {

            requestConfig.signal = activeSearchAbortController.signal;

          }



          response = await apiClient.get("/jobs/search/", requestConfig);



          if (

            response.data &&

            (response.data.results || Array.isArray(response.data))

          ) {

            jobs.value = response.data.results || response.data;

            totalJobs.value = response.data.count || jobs.value.length;




            // Always apply local sorting to ensure consistent behavior

            applySorting(jobs.value);



            // --- Record job search history for logged-in users ---

            if (

              isInitialSearch &&

              authStore.state.isLoggedIn &&

              searchQuery.value.trim()

            ) {

              // Only on explicit search (not pagination, sort, or route-driven refetch)

              // Refresh dropdown next time it opens

              searchHistoryLoaded.value = false;

              apiClient

                .post("/jobseeker/search/record/", {

                  query: searchQuery.value.trim(),

                  filters: {

                    jobType: filters.value.jobType,

                    datePosted: filters.value.datePosted,

                    source: filters.value.source,

                    tags: selectedTags.value,

                    includeDescription: true,

                  },

                })

                .catch((err) => {

                  console.error("Failed to record job search history:", err);

                });

            }

            // --- End record job search history ---

          } else {

            throw new Error("Invalid response format from search endpoint");

          }

        } catch (searchError) {

          const canceled =

            searchError?.code === "ERR_CANCELED" ||

            searchError?.name === "CanceledError" ||

            searchError?.message === "canceled";



          if (canceled) {

            return;

          }



          console.error("Search endpoint failed:", searchError);



          const isTimeout =

            searchError?.code === "ECONNABORTED" ||

            (typeof searchError?.message === "string" &&

              searchError.message.includes("timeout"));



          error.value = isTimeout

            ? "Search timed out. Try again in a moment, or narrow your search with filters."

            : "Failed to search jobs. Please try again.";



          jobs.value = [];

          totalJobs.value = 0;

          return;

        }

      } catch (err) {

        const isCanceled =

          err?.code === "ERR_CANCELED" ||

          err?.name === "CanceledError" ||

          err?.message === "canceled";



        if (isCanceled) {

          return;

        }



        console.error("Error searching jobs:", err);

        error.value = "Failed to search jobs. Please try again.";

        jobs.value = [];

        totalJobs.value = 0;

      } finally {

        if (isMounted.value) {
          loading.value = false;
          hasInitialLoad.value = true;
        }

        if (activeSearchAbortController) {

          activeSearchAbortController = null;

        }

      }

    };



    // Helper function to apply sorting based on sortBy value

    const applySorting = (jobsList) => {

      // For recommended results, preserve backend ordering

      if (sortBy.value === "recommended") return;

      const toTime = (job) => {

        const raw = job?.posted_at || job?.date_posted;

        if (!raw) return 0;

        const t = new Date(raw).getTime();

        return Number.isFinite(t) ? t : 0;

      };

      const sortedJobs = [...jobsList];

      switch (sortBy.value) {

        case "date_asc":

          sortedJobs.sort((a, b) => toTime(a) - toTime(b));

          break;

        case "date_desc":

          sortedJobs.sort((a, b) => toTime(b) - toTime(a));

          break;

        default:

          sortedJobs.sort((a, b) => toTime(b) - toTime(a));

          break;

      }

      jobsList.length = 0;

      sortedJobs.forEach((job) => jobsList.push(job));

    };



    // Apply filters - don't apply when viewing similar jobs

    const applyFilters = () => {

      if (isViewingSimilarJobs.value) return;



      currentPage.value = 1;

      searchJobs(false); // skip search-count increment & empty-input check

    };



    // Reset all filters

    const resetFilters = () => {

      // Don't reset similarToJobId if we're viewing similar jobs

      if (isViewingSimilarJobs.value) {

        const similarJobId = filters.value.similarToJobId;

        filters.value = {

          jobType: "",

          datePosted: "",

          source: DEFAULT_LISTING_SOURCE,

          similarToJobId: similarJobId,

        };

      } else {

        filters.value = {

          jobType: "",

          datePosted: "",

          source: DEFAULT_LISTING_SOURCE,

          similarToJobId: null,

        };

      }

      selectedTags.value = [];

      sortBy.value = "date_desc";

      searchQuery.value = "";

      currentPage.value = 1;

      skipRouteQueryWatch.value = true;

      router.push({ path: "/jobs" });

      searchJobs(false);

    };



    // Reset everything

    const resetAll = () => {

      searchQuery.value = "";

      resetFilters();

      sortBy.value = "date_desc";

      currentPage.value = 1;

      isViewingSimilarJobs.value = false; // Reset the similar jobs flag



      // Clear URL parameters

      router.push({ path: "/jobs" });



      // Fetch all jobs with viewAllJobs instead of fetchJobs

      viewAllJobs();

    };



    // Back to all jobs button

    const goBackToAllJobs = () => {

      isViewingSimilarJobs.value = false;

      filters.value.similarToJobId = null;

      resetAll();

    };



    // Pagination functions - modified for similar jobs

    const goToPage = (page) => {

      if (typeof page === "number") {

        window.scrollTo({ top: 0, behavior: 'instant' });

        currentPage.value = page;



        // If viewing similar jobs, maintain the similar_to parameter

        if (isViewingSimilarJobs.value && filters.value.similarToJobId) {

          const similarJobId = filters.value.similarToJobId;



          // Just update the page number in the URL

          router.push({

            path: "/jobs",

            query: {

              similar_to: similarJobId,

              page: page,

            },

          });



          // We shouldn't need to re-fetch since we should already have all similar jobs

          // Just update the display for pagination

          // This assumes all similar jobs are loaded at once

        } else {

          // Client-side pagination — scroll and animation already handled above

        }

      }

    };



    const nextPage = () => {

      if (currentPage.value < totalPages.value) {

        window.scrollTo({ top: 0, behavior: 'instant' });

        currentPage.value++;



        // If viewing similar jobs, maintain the similar_to parameter

        if (isViewingSimilarJobs.value && filters.value.similarToJobId) {

          const similarJobId = filters.value.similarToJobId;



          // Just update the page number in the URL

          router.push({

            path: "/jobs",

            query: {

              similar_to: similarJobId,

              page: currentPage.value,

            },

          });

        } else {

          // Client-side pagination — scroll and animation already handled above

        }

      }

    };



    const prevPage = () => {

      if (currentPage.value > 1) {

        window.scrollTo({ top: 0, behavior: 'instant' });

        currentPage.value--;



        // If viewing similar jobs, maintain the similar_to parameter

        if (isViewingSimilarJobs.value && filters.value.similarToJobId) {

          const similarJobId = filters.value.similarToJobId;



          // Just update the page number in the URL

          router.push({

            path: "/jobs",

            query: {

              similar_to: similarJobId,

              page: currentPage.value,

            },

          });

        } else {

          // Client-side pagination — scroll and animation already handled above

        }

      }

    };



    // Helper functions

    const truncateDescription = (job) => {
      // Get real description from job - check multiple fields like Telegram bot does
      let description = null;
      
      // Try different description fields that might contain the actual content
      if (job.description && job.description.trim()) {
        description = job.description;
      } else if (job.content && job.content.trim()) {
        description = job.content;
      } else if (job.full_description && job.full_description.trim()) {
        description = job.full_description;
      } else if (job.details && job.details.trim()) {
        description = job.details;
      } else if (job.job_description && job.job_description.trim()) {
        description = job.job_description;
      }
      
      // If no description found, return empty string for fallback
      if (!description || !description.trim()) {
        return "";
      }

      // Remove HTML tags and clean up the text
      const cleanText = description.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
      
      // Return longer preview for better context
      return cleanText.length > 520 ? cleanText.slice(0, 520) + "..." : cleanText;

    };



    const formatPostedDate = (raw) => {

      if (!raw) return "";

      const d = new Date(raw);

      if (Number.isNaN(d.getTime())) return String(raw);

      return new Intl.DateTimeFormat(undefined, {

        month: "long",

        day: "2-digit",

        year: "numeric",

      }).format(d);

    };

    const formatPostedDateTime = (dateString) => {

      if (!dateString) return "Unknown date";

      try {

        const date = new Date(dateString);

        if (isNaN(date.getTime())) {

          return "Invalid date";

        }

        return date.toLocaleString("en-US", {

          year: "numeric",

          month: "short",

          day: "numeric",

          hour: "2-digit",

          minute: "2-digit",

          timeZone: "Asia/Manila",

        });

      } catch (error) {

        console.error("Error formatting date/time:", error);

        return "Invalid date";

      }

    };



    const employerInitials = (employer) => {

      if (!employer) return "CO";



      // If employer is an object with a name property

      if (typeof employer === "object" && employer.name) {

        employer = employer.name;

      }



      // Ensure employer is a string

      if (typeof employer !== "string") {

        return "CO";

      }



      const initials = employer

        .split(" ")

        .map((word) => word[0])

        .join("")

        .substring(0, 2)

        .toUpperCase();



      return initials || "CO";

    };



    // Helper function to get employer logo URL

    const getEmployerLogo = (job) => {

      if (!job) return null;



      return resolveEmployerLogoUrl(job);

    };



    // Helper function to get employer name

    const getEmployerName = (job) => {

      if (!job) return "Company";



      if (job.employer) {

        if (typeof job.employer === "object" && job.employer.name) {

          return job.employer.name;

        }

        if (typeof job.employer === "string") {

          return job.employer;

        }

      }



      return "Company";

    };



    // Helper function to get employer initials for display

    const getEmployerInitials = (job) => {

      if (!job) return "CO";



      const employer = job.employer;

      if (!employer) return "CO";



      // Use existing employerInitials function

      return employerInitials(employer);

    };



    // Toggle job saved status

    const toggleSaveJob = async (job) => {

      if (!authStore.state.isLoggedIn) {

        showLoginPrompt.value = true;

        return;

      }

try {

        // Get current saved state before toggling

        const wasCurrentlySaved = store.getters["savedJobs/isJobSaved"](job.id);



        // Toggle saved state

        const result = await store.dispatch("savedJobs/toggleSaveJob", job);



        // Refresh saved jobs to ensure consistent state

        await store.dispatch("savedJobs/fetchSavedJobs");



        if (result.success) {

          // Show toast notification based on the previous state

          // not the current state, since we want to show what action was taken

          toastType.value = "success";



          if (wasCurrentlySaved) {

            // If it was saved before, we've removed it

            toastTitle.value = "Job Removed";

            toastMessage.value =

              "The job has been removed from your saved jobs.";

          } else {

            // If it wasn't saved before, we've added it

            toastTitle.value = "Job Saved";

            toastMessage.value = "The job has been added to your saved jobs.";

          }



          showToast.value = true;



          // Hide toast after 3 seconds

          setTimeout(() => {

            showToast.value = false;

          }, 3000);

        }

      } catch (error) {

        console.error("Error saving/unsaving job:", error);



        // Show error toast

        toastType.value = "error";

        toastTitle.value = "Error";

        toastMessage.value = "An error occurred. Please try again.";

        showToast.value = true;



        // Hide toast after 3 seconds

        setTimeout(() => {

          showToast.value = false;

        }, 3000);

      }

    };

    // Hide a job from the listing, with an "Undo" action to restore it
    const hideJobAction = async (job) => {
      if (!authStore.state.isLoggedIn) {
        showLoginPrompt.value = true;
        return;
      }

try {
        const result = await store.dispatch("hiddenJobs/hideJob", job);

        await store.dispatch("hiddenJobs/fetchHiddenJobs");

        if (result.success) {
          toastType.value = "success";
          toastTitle.value = "Job Hidden";
          toastMessage.value = "This job won't show up in your listings anymore.";
          toastActionLabel.value = "Undo";
          toastActionCallback.value = async () => {
            await store.dispatch("hiddenJobs/unhideJob", job.id);
            await store.dispatch("hiddenJobs/fetchHiddenJobs");
          };

          showToast.value = true;

          // Hide toast after 5 seconds (a bit longer to give time to undo)
          setTimeout(() => {
            showToast.value = false;
            toastActionLabel.value = "";
            toastActionCallback.value = null;
          }, 5000);
        }
      } catch (error) {
        console.error("Error hiding job:", error);

        toastType.value = "error";
        toastTitle.value = "Error";
        toastMessage.value = "An error occurred. Please try again.";
        toastActionLabel.value = "";
        toastActionCallback.value = null;
        showToast.value = true;

        setTimeout(() => {
          showToast.value = false;
        }, 3000);
      }
    };

    const shareJob = async (job) => {
      if (!job) return;

      const path = getJobDetailPath(job);
      const shareUrl = `${window.location.origin}${path}`;
      const shareTitle = job.title || "Job Opportunity";

      try {
        if (navigator.share) {
          await navigator.share({
            title: shareTitle,
            text: `Check out this job on Applypa: ${shareTitle}`,
            url: shareUrl,
          });
          return;
        }

        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(shareUrl);
          toastType.value = "success";
          toastTitle.value = "Link Copied";
          toastMessage.value = "Job link copied to clipboard.";
          showToast.value = true;
          setTimeout(() => {
            showToast.value = false;
          }, 2500);
          return;
        }

        throw new Error("Share not supported");
      } catch (err) {
        if (err?.name === "AbortError") {
          return;
        }

        toastType.value = "error";
        toastTitle.value = "Unable to Share";
        toastMessage.value = "Please try again or copy the URL manually.";
        showToast.value = true;
        setTimeout(() => {
          showToast.value = false;
        }, 3000);
      }
    };



    // Toggle tag selection

    const toggleTag = (tag) => {

      const index = selectedTags.value.indexOf(tag.id);

      if (index === -1) {

        selectedTags.value.push(tag.id);

      } else {

        selectedTags.value.splice(index, 1);

      }

      applyFilters();

    };



    // Add custom tag

    const addCustomTag = () => {

      if (!tagInput.value.trim()) return;



      // Check if tag already exists (case insensitive and normalize whitespace)

      const normalizedInput = tagInput.value.trim().toLowerCase();

      const existingTag = popularTags.value.find(

        (tag) => tag.name.toLowerCase().trim() === normalizedInput,

      );



      if (existingTag) {

        // Select existing tag if not already selected

        if (!selectedTags.value.includes(existingTag.id)) {

          selectedTags.value.push(existingTag.id);

        }

      } else {

        // Add new tag - use negative ID for custom tags

        const newTag = {

          id: -Date.now(), // Temporary negative ID for client-side tags

          name: tagInput.value.trim(),

          isCustom: true, // Flag to identify custom tags

        };

        popularTags.value.push(newTag);

        selectedTags.value.push(newTag.id);

      }



      tagInput.value = "";

      applyFilters();

    };



    // Helper function to get tag name by id

    const getTagName = (tagId) => {

      const tag = popularTags.value.find((t) => t.id === tagId);

      return tag ? tag.name : `Tag ${tagId}`;

    };



    // Remove a specific tag by id

    const removeTag = (tagId) => {

      const index = selectedTags.value.indexOf(tagId);

      if (index !== -1) {

        selectedTags.value.splice(index, 1);

        applyFilters();

      }

    };



    // Toggle filters

    const toggleFilters = () => {

      showFilters.value = !showFilters.value;

    };



    // Function to fetch all jobs from API with sorting

    const viewAllJobs = async () => {

      loading.value = true;

      error.value = null;

      searchQuery.value = "";

      resetFilters();

      currentPage.value = 1; // Always reset to first page

      try {

        const searchParams = {

          page: 1,

          per_page: MAX_FETCH,

          sort_by: sortBy.value,

        };

        applySourceParams(searchParams);

        const res = await apiClient.get("/jobs/search/", {

          params: searchParams,

        });

        jobs.value = res.data.results;

        totalJobs.value = res.data.count;

        applySorting(jobs.value);

        if (!isMounted.value) return;

        skipRouteQueryWatch.value = true;

        router.push({ path: "/jobs" });

      } catch (err) {

        console.error("Error fetching all jobs:", err);

        if (isMounted.value) error.value = "Failed to load all jobs. Please try again.";

      } finally {

        if (isMounted.value) {
          loading.value = false;
          hasInitialLoad.value = true;
        }

      }

    };



    const setListingSource = (source) => {

      if (isViewingSimilarJobs.value) return;

      if (!listingSources().has(source)) return;

      if (filters.value.source === source) return;

      filters.value.source = source;

      currentPage.value = 1;

      searchJobs(false, "replace");

    };






    const showLoginPrompt = ref(false);

    const handleLogin = () => {

      showLoginPrompt.value = false;

      router.push("/login");

    };

    const handleRegister = () => {

      showLoginPrompt.value = false;

      router.push("/register");

    };

    const handleCancel = () => {

      showLoginPrompt.value = false;

    };



    // Function to handle opening advanced filters

    const openAdvancedFilters = () => {

      showFilters.value = !showFilters.value;

    };






    // Removed expired subscription modal - no longer needed



    // Job status helper functions

    const getStatusText = (status) => {

      const statusMap = {

        active: "Active",

        closed: "Closed",

        expired: "Expired",

        filled: "Position Filled",

        paused: "Paused",

        draft: "Draft",

      };

      return statusMap[status] || "Unknown";

    };



    const getStatusIcon = (status) => {

      const iconMap = {

        active: "fas fa-check-circle",

        closed: "fas fa-times-circle",

        expired: "fas fa-clock",

        filled: "fas fa-user-check",

        paused: "fas fa-pause-circle",

        draft: "fas fa-edit",

      };

      return iconMap[status] || "fas fa-question-circle";

    };



    const getStatusBadgeClass = (status) => {

      const classMap = {

        active: "bg-green-500/15 text-green-700 dark:text-green-300",

        closed: "bg-red-500/15 text-red-700 dark:text-red-300",

        expired: "bg-yellow-500/15 text-yellow-700 dark:text-yellow-300",

        filled: "bg-blue-500/15 text-blue-700 dark:text-blue-300",

        paused: "bg-muted text-muted-foreground",

        draft: "bg-purple-500/15 text-purple-700 dark:text-purple-300",

      };

      return classMap[status] || "bg-muted text-muted-foreground";

    };



    const getStatusButtonClass = (status) => {

      const classMap = {

        closed: "bg-red-500/15 text-red-700 dark:text-red-300",

        expired: "bg-yellow-500/15 text-yellow-700 dark:text-yellow-300",

        filled: "bg-blue-500/15 text-blue-700 dark:text-blue-300",

        paused: "bg-muted text-muted-foreground",

        draft: "bg-purple-500/15 text-purple-700 dark:text-purple-300",

      };

      return classMap[status] || "bg-muted text-muted-foreground";

    };

    // Match score badge color helper
    const matchScoreBadgeClass = (score) => {
      if (score >= 80) return "bg-green-500/15 text-green-700 dark:text-green-300";
      if (score >= 50) return "bg-yellow-500/15 text-yellow-700 dark:text-yellow-300";
      return "bg-muted text-muted-foreground";
    };

    // Show no-skills prompt: logged in, 5+ jobs loaded, all match_score values are null
    const showNoSkillsPrompt = computed(() => {
      if (!authStore.state.isLoggedIn) return false;
      if (jobs.value.length < 5) return false;
      return jobs.value.every((job) => job.match_score == null);
    });

// onboarding prompt watch hidden

    return {

      oljUnlocked,

      // Toast State

      showToast,

      toastType,

      toastTitle,

      toastMessage,

      toastActionLabel,

      handleToastAction,



      // Search & Filter State

      searchQuery,

      jobs,

      totalJobs,

      loading,

      error,

      showFilters,

      filters,

      sortBy,

      hasInitialLoad,



      // Search history dropdown

      searchHistory,

      allSearchHistory,

      showSearchHistoryDropdown,

      showFullHistory,

      totalSearchHistoryCount,

      viewedQueries,

      currentSearchHistory,

      onSearchFocus,

      onSearchBlur,

      onSearchInput,

      selectSearchHistory,

      deleteSearchHistoryItem,

      handleSeeMore,

      handleHide,

      handleClearAll,



      // Tags

      popularTags,

      selectedTags,

      tagInput,

      toggleTag,

      addCustomTag,

      getTagName,

      removeTag,



      // Pagination

      currentPage,

      totalPages,

      displayedPages,

      goToPage,

      nextPage,

      prevPage,

      displayedJobs,



      // Actions

      fetchJobs,

      refreshJobsList,

      checkOljConnection,

      resultsHeading,

      isJobSaved,

      isJobHidden,

      shareJob,

      toggleSaveJob,

      hideJobAction,

      fetchSimilarJobs,

      viewAllJobs,

      searchJobs,

      applyFilters,

      resetFilters,

      clearSearch,

      setListingSource,



      // Helpers

      truncateDescription,

      formatPostedDate,

      formatPostedDateTime,

      employerInitials,

      getEmployerLogo,

      getEmployerName,

      getEmployerInitials,

      getSimilarityLabel,

      getJobDetailPath,
      handleJobCardClick,



      // New state variables

      isViewingSimilarJobs,



      // OLJ connection status

      userHasOljConnection,

      goBackToAllJobs,



      // Auth store

      authStore,



      // New method

      toggleFilters,



      // New method

      openAdvancedFilters,



      showLoginPrompt,

      handleLogin,

      handleRegister,

      handleCancel,






      // New state variable

      // Job status helpers

      getStatusText,

      getStatusIcon,

      getStatusBadgeClass,

      getStatusButtonClass,

      matchScoreBadgeClass,

      showNoSkillsPrompt,

    };

  },

};

</script>



<style>

/* Utility classes */

.line-clamp-2 {

  display: -webkit-box;

  -webkit-line-clamp: 2;

  line-clamp: 2;

  -webkit-box-orient: vertical;

  overflow: hidden;

}

.line-clamp-6 {

  display: -webkit-box;

  -webkit-line-clamp: 6;

  line-clamp: 6;

  -webkit-box-orient: vertical;

  overflow: hidden;

}

/* Page turn animation for job list pagination */
.jobs-page-enter-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.jobs-page-leave-active {
  transition: opacity 0.15s ease;
  position: absolute;
  pointer-events: none;
}
.jobs-page-enter-from {
  opacity: 0;
  transform: translateY(16px);
}
.jobs-page-leave-to {
  opacity: 0;
}

</style>
